import React, { Component } from 'react';

import { Button } from 'devextreme-react/button';
import { Link } from 'react-router-dom';
import AntLocalization from '../utils/AntLocalization';

// import { TbFileArrowRight } from 'react-icons/tb';
// import { TbCircleArrowRight } from 'react-icons/tb';
// import { TbCircleArrowUpRight } from 'react-icons/tb';
import { TbSquareRoundedArrowRight } from 'react-icons/tb';

export default function (props) {
    return (
        <React.Fragment>
            {props.onClick && (
                <Button
                    width={100}
                    className="ant-link-container-in-grid"
                    onClick={() => {
                        if (props.onClick)
                            props.onClick({
                                field: props.field,
                                text: AntLocalization.translateText(props.text),
                                value: props.value,
                                row: props.row,
                                rowData: props.rowData
                            });
                    }}
                    type="normal"
                    stylingMode="text"
                    hoverStateEnabled={false}
                    focusStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <Link
                        className="ant-link-in-grid"
                        target={props.newWindow ? '_blank' : undefined}
                        to={props.linkUrl ? props.linkUrl : '/home'}
                        style={{ textDecoration: 'none' }}
                    >
                        {!props.text && <TbSquareRoundedArrowRight className={'dx-icon'} />}
                        {AntLocalization.translateText(props.text)}
                    </Link>
                </Button>
            )}

            {!props.onClick && props.linkUrl && (
                <div className="ant-grid-link-cell">
                    <Link
                        className="ant-link-in-grid"
                        target={props.newWindow ? '_blank' : undefined}
                        to={props.linkUrl ? props.linkUrl : '/home'}
                        style={{ textDecoration: 'none' }}
                    >
                        {!props.text && <TbSquareRoundedArrowRight className={'dx-icon'} />}
                        {AntLocalization.translateText(props.text)}
                    </Link>
                </div>
            )}
        </React.Fragment>
    );
}


/* {!props.text && <i className={'dx-icon dx-icon-import'}></i>} */
